import { useState, useEffect } from 'react';
import { isMobile } from "~helpers/methods";

export const useIsMobile = () => {
  const [isMobileWindow, setIsMobileWindow] = useState(false)

  const handleResizeWindow = () => setIsMobileWindow(isMobile());

  useEffect(() => {
    setIsMobileWindow(isMobile())

    window.addEventListener('resize', handleResizeWindow)

    return () => window.removeEventListener('resize', handleResizeWindow)
  }, [])

  return isMobileWindow
}